export default __webpack_public_path__ + "static/media/locationShort.16820ea5.svg";